import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableAgent } from "./autogen/AutogenLayoutUserTableAgent";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableAgent extends AutogenLayoutUserTableAgent implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.AGENT;
    }


    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
